/**
 * TanStack Query hooks for `applovin-integration`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	applovinIntegrationQueryKeys,
	type CreateApplovinIntegrationBody,
	type CreateApplovinIntegrationResponse,
	type ListApplovinIntegrationResponse,
} from "./api";

export function useApplovinIntegrationList(): UseQueryResult<ListApplovinIntegrationResponse, Error> {
	return useQuery({
		queryKey: applovinIntegrationQueryKeys.list(),
		queryFn: list,
	});
}

export function useApplovinIntegrationCreate(): UseMutationResult<CreateApplovinIntegrationResponse, Error, CreateApplovinIntegrationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: applovinIntegrationQueryKeys.all });
		},
	});
}

export function useApplovinIntegrationDelete(): UseMutationResult<{ ok: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: applovinIntegrationQueryKeys.all });
		},
	});
}
